import React from 'react';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

export const SIZE_OTHER = 'Other';

export const formatNumber = (value) => {
  if (value == null || Number.isNaN(Number(value))) return '—';
  return Number(value).toLocaleString();
};

export const formatPercent = (value) => {
  if (value == null || Number.isNaN(Number(value))) return '—';
  return `${Number(value).toFixed(1)}%`;
};

/** Pull can size from variant title first, then product title (e.g. "440ml"). */
export const parseCanSize = (...texts) => {
  const matched = texts.find((text) => typeof text === 'string' && /(\d+)\s*ml\b/i.test(text));
  if (!matched) return SIZE_OTHER;
  const match = matched.match(/(\d+)\s*ml\b/i);
  return match ? `${match[1]}ml` : SIZE_OTHER;
};

export const sizeSortKey = (size) => {
  const n = parseInt(size, 10);
  return Number.isNaN(n) ? 9999 : n;
};

export const CustomSpinner = ({ fontSize = 24 }) => (
  <Spin
    indicator={(
      <LoadingOutlined
        style={{ fontSize }}
        spin
      />
)}
  />
);

export const MetricStat = ({
  label, value, icon, loading, color,
  onMouseEnter, onMouseLeave, active, dimmed,
}) => {
  const className = [
    'fresh-club-metric',
    active ? 'fresh-club-metric--active' : '',
    dimmed ? 'fresh-club-metric--dimmed' : '',
  ].filter(Boolean).join(' ');
  return (
    <div
      className={className}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      style={color ? { borderLeftColor: color } : undefined}
    >
      <div className="fresh-club-metric-icon" style={color ? { color } : undefined}>
        {icon}
      </div>
      <div className="fresh-club-metric-text">
        <div className="fresh-club-metric-value">
          {loading ? <CustomSpinner fontSize={18} /> : value}
        </div>
        <div className="fresh-club-metric-label">{label}</div>
      </div>
    </div>
  );
};
